import React from 'react';
export function CostoNoComprar() {
  return <section className="py-[60px] px-5 bg-light" data-id="element-35">
      <div className="max-w-[760px] mx-auto" data-id="element-36">
        <h2 className="text-[22px] md:text-[34px] font-black text-center mb-3 text-text-heading" data-id="element-37">
          ⚖️ ¿Cuánto cuesta <span className="text-gold" data-id="element-38">no tenerlo?</span>
        </h2>

        <div className="overflow-x-auto" data-id="element-39">
          <table className="w-full border-collapse mt-6 text-[14px]" data-id="element-40">
            <thead data-id="element-41">
              <tr data-id="element-42">
                <th className="bg-[#1a1a2e] text-gold p-3 px-4 text-left font-bold" data-id="element-43">
                  SIN MISIÓN INFLUENCIA
                </th>
                <th className="bg-[#1a1a2e] text-gold p-3 px-4 text-left font-bold" data-id="element-44">
                  COSTO REAL
                </th>
              </tr>
            </thead>
            <tbody data-id="element-45">
              {[['Publicar sin estrategia', 'Alcance cero y audiencia que no crece'], ['No saber responder DMs', 'Conversaciones perdidas que podrían transformar vidas'], ['Cuenta sin identidad visual', 'Primera impresión que aleja en vez de conectar'], ['Sin plan de contenido', 'Improvisación semanal que agota y paraliza'], ['Fe separada de tu presencia digital', 'Un año más sin impacto real']].map((row, i) => <tr key={i} className={i % 2 !== 0 ? 'bg-[#0f0f1a]' : ''} data-id="element-46">
                  <td className="p-3 px-4 border-b border-divider text-text-secondary" data-id="element-47">
                    {row[0]}
                  </td>
                  <td className="p-3 px-4 border-b border-divider text-text-secondary" data-id="element-48">
                    {row[1]}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>

        <p className="text-center mt-8 text-lg font-extrabold text-gold" data-id="element-49">
          La próxima semana puede ser completamente distinta. 🇦🇷 ✝️
        </p>
      </div>
    </section>;
}